<template>
  <YoutubeSlider
    v-if="data.template === 'horisontal'"
    :videos="data.data"
    :title="computedTitle(data)"
    :title-analytics="data.title"
    :link="data.link"
    :link-title="data.link_title"
    :id="computedTitle(data)"
  />
  <YoutubeList
    v-else-if="data.template === 'vertical'"
    :videos="data.data"
    :title="computedTitle(data)"
    :title-analytics="data.title"
    :link="data.link"
    :link-title="data.link_title"
    :id="computedTitle(data)"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import YoutubeSlider from './YoutubeSlider'
import YoutubeList from './YoutubeList'

export default {
  name: 'YoutubeBlock',
  components: {
    YoutubeList,
    YoutubeSlider
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  methods: {
    computedTitle (item) {
      return item.show_title === 'Y' ? item.title : ''
    }
  }
}
</script>

<style scoped>

</style>
